import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import {
        Breadcrumb,
        BreadcrumbItem,
        BreadcrumbLink,
        BreadcrumbList,
        BreadcrumbPage,
        BreadcrumbSeparator,
    } from '@/components/ui/breadcrumb';
    import { Link } from '@inertiajs/vue3';
    import { type BreadcrumbItem as BreadcrumbItemType } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    breadcrumbs: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Breadcrumb), null, {
    default: _withCtx(() => [
      _createVNode(_unref(BreadcrumbList), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(_unref(BreadcrumbItem), null, {
                default: _withCtx(() => [
                  (index === _ctx.breadcrumbs.length - 1 || !item.href)
                    ? (_openBlock(), _createBlock(_unref(BreadcrumbPage), { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.translated ? item.title : _ctx.$t(item.title)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_unref(BreadcrumbLink), {
                        key: 1,
                        "as-child": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Link), {
                            href: item.href
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.translated ? item.title : _ctx.$t(item.title)), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ]),
                        _: 2
                      }, 1024))
                ]),
                _: 2
              }, 1024),
              (index !== _ctx.breadcrumbs.length - 1)
                ? (_openBlock(), _createBlock(_unref(BreadcrumbSeparator), { key: 0 }))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})